import highcharts from 'highcharts';
import $ from 'jquery';
import _ from 'lodash';

class HistoryChartController {
  /* @ngInject */
  constructor($element, $filter, $log, $rootScope, $translate, NewDashboardActions, NewDashboardStore, SocialProvisionsDaysFilter, StoreStates, NewUserInstrumentStore, NewTokenService, NewUserInstrumentActions) {
    const that = this;

    const PRIMARY_COLOR = '#236995';

    that.loading = {
      chart: false,
      balance: false
    };

    let balance;
    let chart;

    const getDistinctBalances = (balanceHistory) => {
      const distinctBalances = [];
      _.forEach(balanceHistory, (balanceValue) => {
        // const floatBalance = parseFloat((balanceValue / 100).toFixed(2));
        const floatBalance = parseFloat(balanceValue);
        if (distinctBalances.length === 0) {
          distinctBalances.push(floatBalance);
        } else if (_.last(distinctBalances) !== floatBalance) {
          distinctBalances.push(floatBalance);
        }
      });

      if (distinctBalances.length === 1) { // always show at least a straight line
        distinctBalances.push(distinctBalances[0]);
      }

      return distinctBalances;
    };

    const getXAxisLabels = (data, days) => _.map(Array(data.length), (a, i) => {
      if (i === 0) return `-${days} ${$filter('translate')('common.date.days')}`;
      if (i === data.length - 1) return balance ? $filter('translate')('common.date.today') : $filter('translate')('common.date.yesterday');
      return '';
    });

    const drawChart = () => {
      chart = highcharts.chart($($element).find('.history-chart')[0], {
        chart: {
          type: 'line',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          width: '350',
          height: '250'
        },
        tooltip: false,
        plotOptions: {
          line: {
            marker: {
              states: {
                hover: {
                  enabled: false
                },
                selected: {
                  enabled: false
                }
              },
              fillColor: PRIMARY_COLOR,
              radius: 3
            },
            states: {
              hover: {
                enabled: false
              }
            },
            lineWidth: 2,
            color: PRIMARY_COLOR,
            pointPlacement: 'on'
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        yAxis: {
          tickAmount: 7,
          min: 0,
          labels: {
            step: 6,
            format: '€{value}',
            style: {
              fontFamily: 'bulorounded',
              fontSize: '1.2em'
            }
          },
          title: {
            text: null
          }
        },
        xAxis: {
          id: 'days-axis',
          tickLength: 0,
          labels: {
            // rotation: -90
            style: {
              fontFamily: 'bulorounded',
              fontSize: '1.2em'
            }
          }
        },
        title: {
          text: null
        },
        series: [{
          id: 'balance-series',
          data: []
        }]
      });

      chart.showLoading();
    };

    const setChartData = (chartData) => {
      if (chart === undefined) {
        drawChart();
      }

      const days = chartData.length;
      const distinctBalances = getDistinctBalances(chartData);

      const series = chart.get('balance-series');
      if (series) {
        series.setData(distinctBalances);
      }

      const axis = chart.get('days-axis');
      if (axis) {
        axis.tickInterval = distinctBalances.length - 1;
        axis.setCategories(getXAxisLabels(distinctBalances, days));
        chart.redraw();
      }

      if (!that.loading.chart && !that.loading.balance) {
        chart.hideLoading();
      }
    };

    const loadUserInstruments = () => {
      that.loading.balance = true;
      if (NewUserInstrumentStore.getUserInstrumentListState() === StoreStates.STORE_VALID) {
        if (!NewUserInstrumentStore.isWalletBalancePending()) {
          NewUserInstrumentActions.getWalletBalance();
        }
      } else if (NewUserInstrumentStore.getUserInstrumentListState() !== StoreStates.STORE_PENDING_UPDATE) {
        NewUserInstrumentActions.getUserInstrumentList();
      }
    };

    const loadChart = () => {
      if (NewDashboardStore.getChartStoreState(SocialProvisionsDaysFilter.DEFAULT) === StoreStates.STORE_VALID) {
        that.loading.chart = false;
        const chartData = _.map(NewDashboardStore.getChartData(SocialProvisionsDaysFilter.DEFAULT), (data) => data.balanceValue);
        if (balance) {
          if (balance > -1) {
            if (chartData.length === SocialProvisionsDaysFilter.DEFAULT) {
              chartData.splice(0, 1);
            }

            chartData.push(balance);
          }
          setChartData(chartData);
        }
      } else {
        if (NewDashboardStore.getChartStoreState(SocialProvisionsDaysFilter.DEFAULT) !== StoreStates.STORE_PENDING_UPDATE) {
          that.loading.chart = true;
          NewDashboardActions.getChartData(SocialProvisionsDaysFilter.DEFAULT);
        }
      }
    };

    const init = () => {
      drawChart();
      loadUserInstruments();
      loadChart();
    };

    that.$onInit = init;

    const deregUserInstrumentUpdateListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE', loadUserInstruments);
    const deregUserInstrumentFailListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE_FAIL', () => {
      that.loading.balance = false;
    });

    const deregWalletBalanceUpdateListener = $rootScope.$on('USERINSTRUMENT_WALLETBALANCE_UPDATE', () => {
      const lastBalance = NewUserInstrumentStore.getLastWalletBalance();
      if (lastBalance) {
        // balance = parseFloat((lastBalance / 100).toFixed(2));
        balance = parseFloat(lastBalance).toFixed(2);
      } else {
        balance = -1;
      }

      that.loading.balance = false;

      loadChart();
    });

    const deregChartDataUpdateListener = $rootScope.$on('DASHBOARDCHART_UPDATE', loadChart);
    const deregChartDataFailListener = $rootScope.$on('DASHBOARDCHART_FAIL', () => {
      that.loading.chart = false;
    });

    that.$onDestroy = () => {
      deregUserInstrumentUpdateListener();
      deregUserInstrumentFailListener();
      deregWalletBalanceUpdateListener();
      deregChartDataUpdateListener();
      deregChartDataFailListener();
    };
  }
}

export default HistoryChartController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/historyChart/historyChart.controller.js
 **/